import { render, staticRenderFns } from "./clientProfileTrainingExams.vue?vue&type=template&id=13a97c6a"
import script from "./clientProfileTrainingExams.vue?vue&type=script&lang=js"
export * from "./clientProfileTrainingExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports